<template>
  <li class="tree" :class="{ 'child' : isChild, 'has-not-child' : !hasChildren && !isChild }">
    <slot name="label" :branch="branch" v-if="!hasChildren">{{ branch.label }}</slot>
    <button v-else @click="handleOpen">
       <slot name="label" :branch="branch">{{ branch.label }}</slot>
       <i class="status" :class="{
        'fas fa-chevron-down': !isOpen,
        'fas fa-chevron-up': isOpen
       }" />
    </button>
    <transition name="collapsable">
      <ul v-if="hasChildren && isOpen" class="tree-child">
        <the-tree v-for="child in branch.children" :key="child.label" :branch="child" :is-child="true" >
          <template v-slot:label="slotProps">
            <slot name="label" v-bind="slotProps" />
          </template>
        </the-tree>
      </ul>
    </transition>
  </li>
</template>

<script>
export default {
  name: 'TheTree',
  props: {
    branch: {
      required: true
    },
    isChild: {
      required: false,
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    handleOpen() {
      this.isOpen = !this.isOpen
    }
  },
  computed: {
    hasChildren() {
      return this.branch.children
    }
  }
}
</script>

<style>

li.tree {
  list-style: none;
  /* padding: 8px; */
}


li.tree.child {
  border-left: 1px solid #dcdfe6;
}

li.tree button {
  outline: none;
  border: none;
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  background-color: transparent;
}

/* li.has-not-child + li.has-not-child {
  margin-top: 8px;
} */

ul.tree-child {
  overflow:hidden;
  margin-top: 8px;
}

.collapsable {
  transition: max-height 100ms ease-in-out;
}

.collapsable-enter {
  max-height: 0;
}

.collapsable-enter-active {
  transition: max-height 100ms ease-in-out;
  max-height: 100vh; /* Ajusta según el contenido */
}

.collapsable-leave {
  max-height: 100vh; /* Ajusta según el contenido */
}

.collapsable-leave-active {
  transition: max-height 100ms ease-in-out;
  max-height: 0;
}

</style>
